import React from "react";
import { Typography, Switch } from "@mui/material";
import { SunMoon } from "lucide-react";
import { useThemeMode } from "@/contexts/ThemeContext";

const DarkAndLightMode = () => {
	const { isDarkMode, setIsDarkMode } = useThemeMode();

	const handleToggle = (checked) => {
		setIsDarkMode(checked);
		localStorage.setItem("theme", checked ? "dark" : "light");
	};

	return (
		<div
			style={{
				display: "flex",
				alignItems: "center",
				justifyContent: "space-between",
				borderRadius: "8px",
				marginBottom: "1rem"
			}}>
			<div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
				<SunMoon color={isDarkMode ? "#fff" : "#000"} size={24} />
				<div>
					<Typography component='label' fontWeight='bold' style={{ color: isDarkMode ? "#fff" : "#000" }}>
						Mod întunecat
					</Typography>
					<Typography
						variant='caption'
						style={{ display: "block", color: isDarkMode ? "#aaa" : "#666" }}>
						Activează tema întunecată pentru interfață
					</Typography>
				</div>
			</div>
			<Switch
				checked={isDarkMode}
				onChange={(e) => handleToggle(e.target.checked)}
				color='primary'
			/>
		</div>
	);
};

export default DarkAndLightMode;
